import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { AlertController } from '@ionic/angular';

import connectSearchBox from 'instantsearch.js/es/connectors/search-box/connectSearchBox';
import connectHits from 'instantsearch.js/es/connectors/hits/connectHits';
import connectRefinementList from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import connectConfigure from 'instantsearch.js/es/connectors/configure/connectConfigure';
import InstantSearch from 'instantsearch.js/es/lib/InstantSearch';

import {
  AlgoliaHit,
  AlgoliaInstanceNames
} from '../../constants/algolia';
import { noop } from '../../../utils/utils';
import { BaseAlgoliaComponent } from '../../../utils/algolia';

@Component({
    selector: 'algolia-paired-agents-search',
    templateUrl: './algolia-paired-agents-search.html',
    styleUrls: ['algolia-paired-agents-search.scss'],
    standalone: false
})
export class AlgoliaPairedAgentsSearch
  extends BaseAlgoliaComponent
  implements OnInit
{
  @Output() onLoad = new EventEmitter<void>();

  instanceName = AlgoliaInstanceNames.new_listing_input_admin_search_for_agent;
  noResultsMessage = 'No paired agents found.';

  displayName = '';
  @Input() childComponent!: TemplateRef<any>;

  searchText: string;
  isInputDirty = false;

  // Algolia related fields
  instance: InstantSearch;
  refine: (query: string) => void;
  query: string;
  hits: AlgoliaHit[] = [];
  selectedAgents: AlgoliaHit[] = [];

  constructor(private alertCtrl: AlertController) {
    super();
  }

  async ngOnInit() {
    const { instance, configs } = await this.createInstance(this.instanceName);

    this.instance = instance;
    const { refinements = [], searchParameters = {} } = configs;

    this.instance.addWidgets([
      connectConfigure(noop)({
        searchParameters,
      }),
      connectSearchBox((state) => {
        this.refine = state.refine;
        this.query = state.query;
      })({}),
      connectHits(({ hits }) => {
        this.hits = hits as any;
      })({}),
      ...refinements.map((refinement) => {
        return connectRefinementList(noop)({
          attribute: refinement,
          operator: 'and',
          limit: 10000,
        });
      }),
    ]);

    this.onLoad.emit();
  }

  onInputChange(text: string) {
    this.isInputDirty = true;
    this.searchText = text;
    this.refine(this.searchText);
  }

  clearSearch() {
    this.searchText = '';
    // We want to preserve the selected agents when the search is cleared
    this.hits = this.selectedAgents;
  }

  displayNoResultsLabel() {
    return (
      this.searchText !== '' &&
      this.instance?.status === 'idle' &&
      this.isInputDirty &&
      this.hits.length === 0
    );
  }

  async clickInfoText() {
    const myAlert = await this.alertCtrl.create({
      header: 'Primary Agent',
      message: 'The primary agent on a listing can\'t be changed. They can make changes to the listing that will be autoupdated to other agents assigned to the listing. It\'s common to make the primary agent match the actual listing agent, but it\'s not a requirement.',
      buttons: [
        {
          role: 'cancel',
          text: 'OK',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
      ]
    });
    myAlert.present();
  }
}
